export function isUserDisabled(user) {
  return Boolean(String(user?.disabled_at || user?.disabledAt || "").trim());
}

export function getActiveUsers(users) {
  return (users || []).filter(user => !isUserDisabled(user));
}

export function getUserOperationalLabel(user) {
  if (!user) return "";
  const name = String(user.name || "");
  if (!isUserDisabled(user)) return name;
  const canonicalName = user.canonical_user_name || user.canonicalUserName;
  return canonicalName
    ? `${name}（${canonicalName}へ統合済み）`
    : `${name}（統合済み）`;
}

export function getSimilarNameWarning(existingUsers, proposedName) {
  const normalize = value => String(value || "").trim().replace(/[\s\u3000]+/g, "").toLocaleLowerCase("ja-JP");
  const proposed = normalize(proposedName);
  if (!proposed) return [];
  return (existingUsers || []).filter(user => {
    const current = normalize(user.name);
    return current && (current === proposed || (Math.min(current.length, proposed.length) >= 2 && (current.includes(proposed) || proposed.includes(current))));
  });
}
